import { flashFeed } from "@/mocks/home";

export default function FlashFeed() {
  return (
    <section className="w-full mt-10 md:mt-14 border-y border-background-200/80 bg-background-100/60">
      <div className="w-full flex items-stretch">
        <div className="hidden md:flex items-center gap-2 px-4 md:px-8 bg-primary-500 text-background-50 dark:text-foreground-950 whitespace-nowrap">
          <i className="ri-alarm-warning-line"></i>
          <span className="font-label text-sm font-medium">急报滚动</span>
        </div>
        <div className="flex-1 overflow-hidden py-4">
          <div className="flex w-max animate-marquee">
            {[0, 1].map((dup) => (
              <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
                {flashFeed.map((item) => (
                  <span key={`${dup}-${item.time}`} className="flex items-center">
                    <span className="px-4 md:px-6 flex items-center gap-2.5 whitespace-nowrap">
                      <span className="font-heading text-sm font-bold text-primary-600">
                        {item.time}
                      </span>
                      <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-900 font-label text-[11px]">
                        {item.tag}
                      </span>
                      <span className="font-label text-sm text-foreground-700">{item.text}</span>
                    </span>
                    <span className="w-1.5 h-1.5 rounded-full bg-background-400"></span>
                  </span>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 pb-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {flashFeed.slice(0, 6).map((item) => (
          <a
            key={item.text}
            href="#deep"
            className="group flex items-start gap-3 rounded-md bg-background-50 border border-background-200/70 p-3.5 hover:border-accent-300 transition-colors cursor-pointer"
          >
            <span className="mt-0.5 w-7 h-7 shrink-0 flex items-center justify-center rounded bg-accent-100 text-accent-800">
              <i className="ri-live-line text-sm"></i>
            </span>
            <span className="min-w-0">
              <span className="font-label text-[11px] text-foreground-400">
                {item.time} · {item.tag}
              </span>
              <p className="mt-1 font-label text-sm leading-snug text-foreground-800 group-hover:text-primary-700 transition-colors">
                {item.text}
              </p>
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}